import { render, staticRenderFns } from "./ChooseRegionModal.vue?vue&type=template&id=30295841&scoped=true"
import script from "./ChooseRegionModal.vue?vue&type=script&lang=js"
export * from "./ChooseRegionModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30295841",
  null
  
)

export default component.exports